/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-report-template-grid.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { TFunction } from 'i18next';
import { CustomReportTemplateFields } from '@components/admin/admin-custom-report-template-grid/admin-custom-report-template-grid.settings';
import { RIGHT_END_REPORT_TEMPLATE_COLUMNS } from '@components/admin/admin-report-template-grid/admin-report-template-grid.data';
import { useGridCells } from 'hooks/index';
import { IExpandableGridColumnV2 } from 'views/components/core/expandable/grid-v2/interfaces-v2/grid-props-v2.interface';
import { GridColumnDateFilter, GridColumnMenuActiveFilter } from 'views/components/core/grid-filters';

const { MaxLengthCell, NumberCell, YesNoCell, DateCell } = useGridCells();

export const CUSTOM_REPORT_TEMPLATE_COLUMNS = (
    t: TFunction,
): IExpandableGridColumnV2<keyof CustomReportTemplateFields>[] => [
    {
        label: t('admin:templateInUse'),
        id: 'inUse',
        field: 'inUse',
        minWidth: 120,
        lockedByDefault: true,
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        label: t('admin:type'),
        id: 'templateTypeName',
        field: 'templateTypeName',
        headerClass: 'border',
        minWidth: 120,
        lockedByDefault: true,
    },
    {
        label: t('admin:templateName'),
        field: '_customTemplateName',
        id: 'template-name',
        headerClass: 'border',
        minWidth: 208,
        lockedByDefault: true,
        cells: { data: MaxLengthCell(50) },
    },
    {
        label: t('ra:description'),
        field: 'description',
        id: 'template-description',
        headerClass: 'border',
        minWidth: 208,
        cells: { data: MaxLengthCell(50) },
    },
    {
        label: t('common:module'),
        field: 'moduleName',
        id: 'template-module',
        headerClass: 'border',
        minWidth: 120,
        cells: { data: MaxLengthCell(50) },
    },
    {
        label: t('common:format'),
        field: 'reportFormatName',
        id: 'template-format',
        headerClass: 'border',
        minWidth: 120,
        cells: { data: NumberCell },
    },
    ...(RIGHT_END_REPORT_TEMPLATE_COLUMNS(t) as IExpandableGridColumnV2<keyof CustomReportTemplateFields>[]),
    {
        label: t('reports:templateInUseUpdatedBy'),
        field: 'organizationReportTemplateUpdatedByName',
        id: 'template-in-use-updated-by',
        headerClass: 'border',
        minWidth: 175,
        showByDefault: false,
    },
    {
        label: t('reports:templateInUseUpdatedDate'),
        field: 'organizationReportTemplateUpdatedDate',
        id: 'template-in-use-updated-date',
        headerClass: 'border',
        minWidth: 175,
        cells: { data: DateCell },
        showByDefault: false,
        filterUi: GridColumnDateFilter,
        filter: 'date',
    },
    {
        label: t('reports:reportTemplateID'),
        field: '_itemId',
        id: 'report-template-id',
        minWidth: 150,
        showByDefault: false,
    },
    {
        label: t('reports:organizationTemplateId'),
        field: '_orgDbId',
        id: 'organization-template-id',
        minWidth: 150,
        showByDefault: false,
    },
];
